import { render, staticRenderFns } from "./LastSearchItem.vue?vue&type=template&id=bf9b539e&scoped=true"
import script from "./LastSearchItem.vue?vue&type=script&lang=ts"
export * from "./LastSearchItem.vue?vue&type=script&lang=ts"
import style0 from "./LastSearchItem.vue?vue&type=style&index=0&id=bf9b539e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b539e",
  null
  
)

export default component.exports